document.addEventListener('DOMContentLoaded', function() {
  // Find all video banner link elements
  const videoBannerLinks = document.querySelectorAll('a.video-banner-link');
  
  // Add click event listener to prevent slideshow navigation
  videoBannerLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Check if the click is on a button inside the banner
      if (e.target.closest('button, [role="button"]') && !e.target.closest('a.video-banner-link')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      
      // For the video banner link itself, prevent slideshow navigation
      e.stopPropagation();
      e.stopImmediatePropagation();
    }, true);
    
    // Add hover effect
    link.addEventListener('mouseenter', function() {
      this.style.opacity = '0.9';
      this.style.transition = 'opacity 0.2s ease';
    });
    
    link.addEventListener('mouseleave', function() {
      this.style.opacity = '1';
    });
  });
});
